import PromotionLanding from "./PromotionLanding";

export default PromotionLanding;